// Focus Journey tree goal: recurring (per day/week/month), cumulative (toward N
// chapters / whole Bible), or follow an active reading plan.
import { getReadChapters, readCount } from "./storage";
import { getPlanState } from "./personal";
import { PLANS } from "../data/readingPlans";

const GKEY = "fw_goal";
export const DEFAULT_GOAL = { mode: "recurring", target: 4, period: "day" };

export const getGoal = () => {
  try {
    return { ...DEFAULT_GOAL, ...(JSON.parse(localStorage.getItem(GKEY)) || {}) };
  } catch {
    return { ...DEFAULT_GOAL };
  }
};
export const setGoal = (g) => localStorage.setItem(GKEY, JSON.stringify(g));

function periodStart(period) {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  if (period === "week") {
    const dow = (d.getDay() + 6) % 7; // Monday = 0
    d.setDate(d.getDate() - dow);
  } else if (period === "month") {
    d.setDate(1);
  }
  return d.getTime();
}

const PERIOD_LABEL = { day: "today", week: "this week", month: "this month" };

export function goalProgress() {
  const g = getGoal();

  if (g.mode === "plan" && g.planId) {
    const plan = PLANS.find((p) => p.id === g.planId);
    const st = getPlanState()[g.planId];
    const total = plan ? plan.days.length : 0;
    const done = st ? Object.keys(st.done || {}).length : 0;
    return {
      done,
      target: total,
      pct: total ? Math.min(done / total, 1) : 0,
      headline: plan ? plan.title : "Reading plan",
      detail: total ? `${done} / ${total} days complete` : "Start the plan to begin",
      mode: "plan",
      planId: g.planId,
    };
  }

  if (g.mode === "cumulative") {
    const done = readCount();
    const target = g.target || 1189;
    return {
      done,
      target,
      pct: target ? Math.min(done / target, 1) : 0,
      headline: target >= 1189 ? "Whole Bible" : `${target} chapters`,
      detail: `${done} / ${target} chapters read`,
      mode: "cumulative",
    };
  }

  // recurring
  const start = periodStart(g.period || "day");
  const done = Object.values(getReadChapters()).filter((ts) => ts >= start).length;
  const target = g.target || 4;
  return {
    done,
    target,
    pct: target ? Math.min(done / target, 1) : 0,
    headline: `${target} chapter${target > 1 ? "s" : ""} a ${g.period || "day"}`,
    detail: `${done} / ${target} ${PERIOD_LABEL[g.period || "day"]}`,
    mode: "recurring",
    period: g.period || "day",
  };
}
